import React, { Fragment } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { CapitalizeNames } from 'src/utils/capitalize';
import { Avatar, Box, Link, Typography, makeStyles } from '@material-ui/core';
import useAuth from 'src/hooks/useAuth';
import { AWS_S3 } from 'src/constants/crm/aws';
import getInitials from 'src/utils/getInitials';
import moment from 'moment';
import {
    HalloweenFrame,
    BirthdayFrame,
    DeadsDayFrame,
    ChristmasFrame,
} from 'src/components/Frames';

const useStyles = makeStyles(() => ({
    avatar: {
        cursor: 'pointer',
        width: 84,
        height: 84,
        textDecoration: 'none',
    },
}));

/**
 * Represents the user info for the dashboard layout.
 *
 * @return {*}
 */
export const UserInfo = () => {
    const classes = useStyles();
    const { user } = useAuth();

    const isHalloween = moment().format('DD MM') === '31 10';

    const isBirthday =
        user?.birthday &&
        moment(user.birthday).format('DD MM') === moment().format('DD MM');

    const isDeadsDay = moment().format('DD MM') === '02 11';

    const isDecember = moment().format('MM') === '12';

    const useFrame = () => {
        if (isHalloween) return HalloweenFrame;
        if (isBirthday) return BirthdayFrame;
        if (isDeadsDay) return DeadsDayFrame;
        if (isDecember) return ChristmasFrame;

        return Fragment;
    };

    const Frame = useFrame();

    return (
        <Box p={3}>
            <Frame>
                <Box display="flex" justifyContent="center">
                    <Avatar
                        component={RouterLink}
                        to="/account"
                        alt="User"
                        className={classes.avatar}
                        src={`${AWS_S3}${user?.image || ''}`}
                    >
                        {getInitials(user?.name || '')}
                    </Avatar>
                </Box>

                <Box mt={2} textAlign="center">
                    <Link
                        component={RouterLink}
                        to="/account"
                        variant="h5"
                        color="textPrimary"
                        underline="none"
                    >
                        {CapitalizeNames(user?.name)}
                    </Link>
                    {user?.job && (
                        <Typography variant="body2" color="primary">
                            {user.job}
                        </Typography>
                    )}
                </Box>
            </Frame>
        </Box>
    );
};
